/**
 * "Overdue" on the task, project and deliverable pages (punch list F150,
 * Jeremy 30 Oct 2026, option C). The rule is `daysOverdue` in shared, the
 * one My calendar uses; this is only what the pages say with it. Today is
 * the reader's own calendar day (`todayLocal`), passed in so tests need no
 * clock.
 */
import { daysOverdue, type TaskView } from "@fieldpath/shared";

/** "Overdue 2 days", "Overdue 1 day". */
export function overdueText(days: number): string {
  return `Overdue ${days} day${days === 1 ? "" : "s"}`;
}

/** Finished work is never overdue: Done, or cancelled. */
const finished = (t: Pick<TaskView, "status" | "cancelledAt">) => t.status === "Done" || t.cancelledAt !== null;

/** Days the task's OWN due date is behind, or null. */
export function taskDaysOverdue(t: Pick<TaskView, "dueDate" | "status" | "cancelledAt">, today: string): number | null {
  return daysOverdue(t.dueDate, today, finished(t));
}

/**
 * A row on the project or deliverable page: its own date has passed, or the
 * open stage holding it has. A stage the route skipped is never the current
 * one, so it never marks a row.
 */
export function rowOverdue(
  t: Pick<TaskView, "dueDate" | "currentStageDueDate" | "status" | "cancelledAt">,
  today: string,
): boolean {
  return taskDaysOverdue(t, today) !== null || daysOverdue(t.currentStageDueDate, today, finished(t)) !== null;
}
